import { Exclude, Expose } from "class-transformer";

@Exclude()
export class UpdateCartItemDto {
    @Expose()
    readonly sku: string;

    @Expose()
    readonly cart_id: number;

    @Expose()
    readonly excluded: boolean;

    @Expose()
    readonly quantity: number;
}
